module.exports = __webpack_public_path__ + "img/calendar-minus.6a422013.svg";